<template>
  <wh-popup
    v-model="myVisible"
    :ref-form="$refs.pickInfoForm"
    title="产品信息"
    @close="hidePopup"
    @open="open"
  >
    <div class="product-image">
      <wh-upload v-model="productPic" :max-count="1" />
    </div>
    <van-form ref="pickInfoForm" label-width="60px" class="form" @submit="submitForm">
      <van-field v-model="form.productName" disabled label="名称" />
      <van-field
        name="plantStandard"
        :label="`${currentPlantTypeData.plantType}标准`"
      >
        <template #input>
          <van-radio-group
            v-model="form.productPlantStandard"
            direction="horizontal"
            class="radio-group"
          >
            <van-radio v-for="(item,key) in plantStandard" :key="key" class="radio-group-item" :name="item.value">
              {{ item.label }}
            </van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field :value="form.productPickTime" label="采收时间" disabled />
    </van-form>
  </wh-popup>
</template>

<script>
import { popup } from '@/utils/mixins/popup'
import WhPopup from '@/components/public/WhPopup/WhPopup'
import WhUpload from '@/components/public/WhUpload/WhUpload'
import { PLANT_TYPE_DATE, PLANT_STANDARD } from '@/constant/common'
import { UPLOAD_CONFIG } from '@/constant/config'

export default {
  name: 'PickInfoPopup',
  components: { WhUpload, WhPopup },
  mixins: [popup],
  props: {
    form: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      plantTypeData: { ...PLANT_TYPE_DATE },
      plantStandard: { ...PLANT_STANDARD },
      currentPlantTypeData: {}
    }
  },
  computed: {
    productPic: {
      get() {
        if (this.form.productPic) {
          return [
            {
              url: this.form.productPic
            }
          ]
        } else {
          return []
        }
      },
      set(val) {
        if (val && val.length) {
          this.form.productPic = `${UPLOAD_CONFIG.fetchUrl}${val[0].key}`
        } else {
          this.form.productPic = ''
        }
      }
    }
  },
  methods: {
    open() {
      if (this.form.productCropType && this.form.productCropType in this.plantTypeData) {
        this.currentPlantTypeData = { ...this.plantTypeData[this.form.productCropType] }
      }
    },
    submitForm() {
      this.hidePopup()
    }
  }
}
</script>

<style lang='less' scoped>

  @uploader-size: 40px;
.product-image {
  border-radius: 100%;
  text-align: center;
  margin-top: 40px;
  .pick-info-form {
    display: block;
  }
}
.form {
  margin-top: 20px;
}
</style>
